import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as customizeSlice from "../../../../redux/slices/customizeSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const DropPoint = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [sortNumber, setSortNumber] = useState(undefined);
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [imageId, setImageId] = useState(undefined);
  const [bannerType, setBannerType] = useState("Image"); // New state for banner type
  const [selectedVideo, setSelectedVideo] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [id, setId] = useState();

  const { locationData } = useSelector((state) => state.locationSlice);
  const { allDropPoints, loading } = useSelector((state) => state.customizeSlice);

  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);


  useEffect(() => {
    dispatch(customizeSlice.getDropPoints());
    dispatch(locationSlice.getLocation());

  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = (id) => {
    setDeleteModal(true);
    setDeletableId(id);
  };

  const handleDeleteImage = async () => {
    await dispatch(customizeSlice.destroyDropPoints(deletableId));
    dispatch(customizeSlice.getDropPoints());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Drop Point Name",
      selector: (row) => row?.drop_name || "-",
      sortable: true,
    },
    {
      name: "Destination Name",
      selector: (row) => row?.destination?.destination_name || "-",
      sortable: true,
    },
    {
      name: "Latitude",
      selector: (row) => row?.latitude || "-",
      sortable: true,
    },
    {
      name: "Longitude",
      selector: (row) => row?.longitude || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allDropPoints?.find((h) => h?.id === id);
    setId(data?.id);
    // console.log(data,"pay");
    setForm({
      ...form,
      destination_id: data?.destination_id,
      drop_name: data?.drop_name,
      lat: data?.latitude,
      long: data?.longitude,
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    const { drop_name, destination_id,lat,long} = form;

    formData.append("destination_id", destination_id);
    formData.append("drop_name", drop_name);
    formData.append("lat", lat);
    formData.append("long", long);

    await dispatch(customizeSlice.updateDropPoints(formData, id, setForm));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getDropPoints());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    const { drop_name, destination_id,lat,long} = form;
    formData.append("destination_id", destination_id);
    formData.append("drop_name", drop_name);
    formData.append("lat", lat);
    formData.append("long", long);
   
    await dispatch(customizeSlice.storeDropPoints(formData, setForm));
    setShowAddTempleModal(false);
    dispatch(customizeSlice.getDropPoints());
  };

  // console.log(allPickupPoints,"allPickupPoints")
  return (
    <>
      <h5 className="mb-4"> Drop Points</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <h6>Added Points:</h6>
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddTempleModal(true);
            }}
          >
            Add Drop Point
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allDropPoints?.length && allDropPoints) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      <DeleteModal
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleDelete={handleDeleteImage}
        name={"Drop Point"}
      />

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Update" : "Add"} Drop Point
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="templeSelect" className="mb-3">
            <Form.Label>Select Destination</Form.Label>
            <Form.Select   value={form.destination_id || ""} onChange={(e) => setForm({...form,destination_id:e.target.value})}>
              <option value="">Select Temple</option>
              {locationData?.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.destination_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Drop Point Name</Form.Label>
              <Form.Control
                type="text"
                value={form?.drop_name}
                onChange={(e) =>
                  setForm({ ...form, drop_name: e.target.value })
                }
                placeholder="Enter point name"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Lat</Form.Label>
              <Form.Control
                type="number"
                value={form?.lat}
                onChange={(e) => setForm({ ...form, lat: e.target.value })}
                placeholder="Enter lat"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Long</Form.Label>
              <Form.Control
                type="number"
                value={form?.long}
                onChange={(e) => setForm({ ...form, long: e.target.value })}
                placeholder="Enter long"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update 
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DropPoint;
